import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MonthlyChallengeContent } from 'src/app/challenges/services/models/challenges.model';
import { SwiperConfigType } from 'src/app/models/record-swiper';
import { LocaleService } from 'src/app/services/locale.service';
import { Util } from 'src/app/util';
import { SwiperOptions } from 'swiper/types/swiper-options';

@Component({
  selector: 'app-challenges-monthly-content',
  templateUrl: './challenges-monthly-content.component.html',
  styleUrls: ['./challenges-monthly-content.component.scss']
})
export class ChallengesMonthlyContentComponent implements OnInit {
  readonly swiperConfig: SwiperOptions = {
    breakpoints: undefined,
    spaceBetween: 12,
    slidesPerView: 'auto',
  }

  readonly swiperType = SwiperConfigType.FEATURED;

  @Input() swiperMonthlyItems!: MonthlyChallengeContent[];
  textDirection: string;

  constructor(
    private localeService: LocaleService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.textDirection = this.localeService.getTextDirection();
  }

  navToInfo(monthlyItem: MonthlyChallengeContent) {
    const toSlug = monthlyItem.title || '';
    const slug = Util.slugify(toSlug) + '-' + monthlyItem.recordId;
    this.router.navigate(['/info', slug]);
  }
}
